var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadTimeselect = function SvgFadTimeselect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.254 25s48.253.303 54.601.303c6.35 0 4.887 10.672 9.524 10.596 4.637-.075 3.773-10.899 9.127-10.899 5.353 0 55.326.303 55.326.303v16.55l-55.049-.522-.017 172.48 54.066.187V231s-51.437-1.257-56.008-.506c-4.57.75-4.41-9.416-7.816-9.55-3.406-.134-2.774 8.985-6.56 8.985-3.788 0-57.194.193-57.194.193l-.047-16.957 53.453.833 1.41-172.24-54.816.096V25z",
    fillRule: "evenodd"
  })));
};
export { SvgFadTimeselect as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-timeselect.3b6faa08.svg";